module.exports = __webpack_public_path__ + "img/character-concepts.a18a0dfb.png";